import "./DashboardHeader.css";

const DashboardHeader = ({title}) => {
  let pageName = title;
  if (pageName === undefined) {
    pageName = "error";
  }
  return (
    <div className="dashboard-header">
      <h1>{pageName}</h1>
    </div>
  );
};

export default DashboardHeader;